// extracted by mini-css-extract-plugin
module.exports = {"operatorsSection":"styles-module__operatorsSection___XGQAN","investorsSection":"styles-module__investorsSection___1fHBd","emergingSection":"styles-module__emergingSection___17ikv"};